import { useState } from 'react';
import { Icon, IconButton } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { RiInformation2Line, RiCloseFill } from '@remixicon/react';

import messages from './messages';
import './EmptyStateAlert.scss';

const EmptyStateAlert = () => {
  const intl = useIntl();
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  return (
    <div className="empty-state-alert" role="status">
      <Icon src={RiInformation2Line} className="empty-state-alert__icon" />
      <div className="empty-state-alert__message">
        {intl.formatMessage(messages.emptyStateAlert)}
      </div>
      <IconButton
        src={RiCloseFill}
        iconAs={Icon}
        alt={intl.formatMessage(messages.emptyStateAlertClose)}
        onClick={() => setShow(false)}
        variant="ghost-primary"
        size="lg"
        className="empty-state-alert__close"
      />
    </div>
  );
};

export default EmptyStateAlert;
